var map = {
	"./AiExpressionSummary": 79549,
	"./AiExpressionSummary.scss": 78130,
	"./AiExpressionSummary.tsx": 79549,
	"./AlphaFoldAttributeSection": 6047,
	"./AlphaFoldAttributeSection.tsx": 6047,
	"./CompoundRecordClasses.CompoundRecordClass": 33017,
	"./CompoundRecordClasses.CompoundRecordClass.jsx": 33017,
	"./GeneRecordClasses.GeneRecordClass": 54795,
	"./GeneRecordClasses.GeneRecordClass.jsx": 54795,
	"./PathwayRecordClasses.PathwayRecordClass": 20755,
	"./PathwayRecordClasses.PathwayRecordClass.jsx": 20755,
	"./PathwaySearchById": 17911,
	"./PathwaySearchById.tsx": 17911,
	"./PopsetRecordClasses.PopsetRecordClass": 40767,
	"./PopsetRecordClasses.PopsetRecordClass.jsx": 40767,
	"./ResultExportSelector": 47012,
	"./ResultExportSelector.tsx": 47012,
	"./SequenceRecordClasses.SequenceRecordClass": 55581,
	"./SequenceRecordClasses.SequenceRecordClass.jsx": 55581,
	"./SnpRecordClasses.SnpRecordClass": 5959,
	"./SnpRecordClasses.SnpRecordClass.jsx": 5959,
	"./TranscriptRecordClasses.TranscriptRecordClass": 85609,
	"./TranscriptRecordClasses.TranscriptRecordClass.jsx": 85609,
	"./TranscriptRecordClasses.TranscriptRecordClass.scss": 34404,
	"./gene-list-export-utils": 37370,
	"./gene-list-export-utils.tsx": 37370,
	"./pathway-utils": 6026,
	"./pathway-utils.ts": 6026,
	"./utils": 49033,
	"./utils.js": 49033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78956;